(function($) {window.initMap = function() {
	const $map = $('.map');

	if ($map.length === 0) return;

	const latLng = {lat: 51.652123, lng: -0.200545};
	const styles = [
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#6600ff"
				},
				{
					"saturation": -11
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "33"
				},
				{
					"hue": "#6600ff"
				},
				{
					"lightness": "2"
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "poi.attraction",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.business",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.government",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.medical",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.place_of_worship",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.school",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "poi.sports_complex",
			"elementType": "all",
			"stylers": [
				{
					"saturation": "-58"
				},
				{
					"lightness": "28"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"hue": "#5e00ff"
				},
				{
					"saturation": -79
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "all",
			"stylers": [
				{
					"lightness": 30
				},
				{
					"weight": 1.3
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				},
				{
					"hue": "#5e00ff"
				},
				{
					"saturation": -16
				}
			]
		},
		{
			"featureType": "transit.line",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -72
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -65
				},
				{
					"hue": "#1900ff"
				},
				{
					"lightness": 8
				}
			]
		}
	];

	const map = new google.maps.Map($map[0], {
		center: latLng,
		zoom: 16,
		styles
	});

	var marker = new google.maps.Marker({
		position: latLng,
		map: map,
		title: 'Barnet & Southgate College',
		icon: {
			url: '../../static/img/icon/map-marker.png',
			size: new google.maps.Size(60, 84),
			scaledSize: new google.maps.Size(30, 42),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(30, 42)
		},
		disableDefaultUI: true
	});
};jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);